import React, { Component } from 'react';

import AddressSearch from '../../../../../Shared/React/js/components/addressSearch/AddressSearch';

export default class HomeLocationSearch extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var that = this;
            WhistleOut.getCurrentLocationViaHtml5(function (e) {
                const address = e.label;
                if (address.length > 1) {
                    that.searchInput.value = address;
                }
            });
        }, 500);
    }

    render() {
        const searchAddressProps = {
            className: 'form-group',
            inputClassName: 'font-5',
            countryCode: this.props.countryCode,
            placeholder: this.props.text.addressSearchPlaceHolder,
            addressNotFoundMessage: null,
            commonErrorMessage: null,
            types: this.props.types,
            apiKey: this.props.apiKey,
            queryDelay: this.props.queryDelay
        };

        return (
            <React.StrictMode>
                <div className="form-group">
                    <AddressSearch {...searchAddressProps} />
                </div>
            </React.StrictMode>
        );
    }
}
